import { render, staticRenderFns } from "./DetailsChat.vue?vue&type=template&id=e2a9bf92"
import script from "./DetailsChat.vue?vue&type=script&lang=js"
export * from "./DetailsChat.vue?vue&type=script&lang=js"
import style0 from "./DetailsChat.vue?vue&type=style&index=0&id=e2a9bf92&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerIos,QVirtualScroll});
